import { Stack, Typography, Card } from '@ace-clublabs/shared-component-library';
import { useGlobalState } from '../../state/state';
import { MembersOverview, RVMotorcycle, Address } from './OverviewItems';

export const MembershipOverview = () => {
  const [memberDetails] = useGlobalState('memberDetails');
  const canChangeMembership = memberDetails?.loggedInMember?.rules?.changeMembership;

  return (
    <>
      <Stack>
        <Typography
          variant="h5"
          sx={{ marginBottom: '1rem', '@media (max-width: 769px)': { marginTop: '2rem' } }}
          id="membership-overview-label"
        >
          Membership overview
        </Typography>
        <Card sx={{ padding: '0px' }}>
          <MembersOverview />
          {canChangeMembership && (
            <>
              <RVMotorcycle />
              <Address />
            </>
          )}
        </Card>
      </Stack>
    </>
  );
};
